const contacts = {
  tel: {
    to: 'tel:0160889494',
    value: '01 60 88 94 94'
  },
  mail: {
    to: 'mailto:fermetures.sans.souci@gmail.com',
    value: 'fermetures.sans.souci@gmail.com'
  },
  location: {
    to: 'https://www.google.com/maps/place/Sans+Souci/@48.5968091,2.4727015,17z/data=!3m1!4b1!4m5!3m4!1s0x47e5e721459d8ff9:0x43a741105f3ef661!8m2!3d48.5968091!4d2.4748902',
    value: '75 bd Fontainebleau, 91100 Corbeil Essonnes'
  },
};

export default contacts;
